import type { EventSeriesPollingRequest } from '@/types/event';


export function usePollingEventSeries(
	timeout: number = 60000, // Default timeout set to 60 seconds
	interval: number = 3000, // Default interval set to 5 seconds
) {
	const intervalId = ref<ReturnType<typeof setTimeout>>();
	const timeoutId = ref<ReturnType<typeof setTimeout>>();
	const resolver = ref();
	const eventStore = useEventStore();

	async function clearPolling() {
		if (intervalId.value) {
			clearInterval(intervalId.value);
		}

		if (timeoutId.value) {
			clearTimeout(timeoutId.value);
		}
	}

	async function startPolling(payload: EventSeriesPollingRequest) {
		intervalId.value = setInterval(async () => {
			await eventStore.getEventSeriesStatus(payload);
		}, interval);

		// Set a timeout to stop polling after the specified time
		timeoutId.value = setTimeout(() => {
			clearPolling();
			resolver.value();
		}, timeout);
	}

	function retrieveEventSeriesDetail(payload: EventSeriesPollingRequest) {
		startPolling(payload);

		return new Promise((resolve) => {
			resolver.value = resolve;
		});
	}

	watch(() => eventStore.duplicate.eventSeriesResult, async (result) => {
		if (result) {
			resolver.value(eventStore.duplicate.eventSeriesResult);
			clearPolling();
		}
	});

	watch(() => eventStore.duplicate.errorMessage, async (errorMessage) => {
		// Stop polling when got error
		if (errorMessage) {
			resolver.value();
			clearPolling();
		}
	});

	return {
		retrieveEventSeriesDetail,
	};
}